/****************************************************
 * Module Name:  AddLotCreationModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import Constants from "../../../utility/constants";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, CircularProgress, TextField, Typography, } from "@mui/material";
import Utility from "../../../utility/utility";
import CommonSnackbar from "../../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import LotIntimationProxy from "../../../utility/proxy/manager/manufacturingProxy/lotIntimationProxy";
import logo from '../../../images/pansuriya.jpg'
import dayjs from "dayjs";
import SaveIcon from '@mui/icons-material/Save';
import Select from "react-select";

export default class AddLotCreationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newDateReceive: new Date(),
      newCarat: this.props.editOperation ? this.props.sourceData.carats : "",
      newPcs: this.props.editOperation && this.props.sourceData.pcs ? this.props.sourceData.pcs : "",
      newPrice: "",
      newTotal: "",
      newLotintimationId: this.props.editOperation ? this.props.sourceData.lotintimationid : "",
      disableWeight: false,
      disablePcs: false,
      newInvoiceDate: new Date(),
      newInvoiceNo: "",
      newPaymentDate: null,
      newPaymentDays: "",
      currencyType: "USD",
      newCurrencyRate: "",
      showError: false,
      vendorOptions: [],
      showVendorLoadSpinner: true,

      validateLotCreationPresentSpinner: false,
      showValidationMessage: false,
      lotCreationAvailable: true,

      caratValidationError: "",
      pcsValidationError: "",
      invoiceNoValidationError: "",
      paymentDaysValidationError: "",
      currencyRateValidationError: "",
      priceValidationError: "",
      lotintimationIdValidationError: "",
      tenderid: this.props.editOperation ? this.props.sourceData.tenderid : "",
    };
  }

  handleSave = () => {
    let data = {
      carats: this.state.newCarat,
      price: this.state.newPrice,
      pcs: this.state.newPcs,
      total: this.state.newTotal,
      date:
        Utility.ConvertLocalTimeToUtc(new Date()).slice(0, 11) +
        "00:00:00.000Z",
      datereceived:
        Utility.ConvertLocalTimeToUtc(this.state.newDateReceive).slice(0, 11) +
        "00:00:00.000Z",
      lotintimationid: Number(this.state.newLotintimationId),
      tenderid: this.state.tenderid,
      invoicedate:
        Utility.ConvertLocalTimeToUtc(this.state.newInvoiceDate).slice(0, 11) +
        "00:00:00.000Z",
      invoiceno: this.state.newInvoiceNo,
      paymentdate:
        Utility.ConvertLocalTimeToUtc(this.state.newPaymentDate).slice(0, 11) +
        "00:00:00.000Z",
      paymentdays: this.state.newPaymentDays,
      currencytype: this.state.currencyType,
      currencyrate: this.state.newCurrencyRate,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateLotCreationPresent = (lotCreationEntered) => {
    if (!lotCreationEntered || lotCreationEntered.trim() === "") return;

    this.setState({
      validateLotCreationPresentSpinner: true,
    });

    LotIntimationProxy.GetSingleLotIntimation(
      lotCreationEntered,
      (response) => {

        //if we got response that means lotCreation is present at backend
        if (response && !response.received) {
          //LotCreationName already present
          this.setState({
            validateLotCreationPresentSpinner: false,
            showValidationMessage: true,
            lotCreationAvailable: true,
            newCarat: response.carats ? response.carats : "",
            newPcs: response.pcs ? response.pcs : "",
            disableWeight: true,
            disablePcs: response.pcs ? true : false,
          });
          if (response.carats)
            this.handleUpdateCarat(response.carats);
        } else {
          //LotCreationName not available, so can be used
          this.setState({
            validateLotCreationPresentSpinner: false,
            showValidationMessage: true,
            lotCreationAvailable: false,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    return (
      this.state.priceValidationError.length !== 0 ||
      this.state.newCarat.length === 0 ||
      this.state.newPrice.length === 0 ||
      this.state.newTotal.length === 0 ||
      this.state.newPcs.length === 0 ||
      this.state.pcsValidationError.length !== 0 ||
      this.state.lotintimationIdValidationError.length !== 0 ||
      this.state.newLotintimationId.length === 0 ||
      !this.state.lotCreationAvailable ||
      this.state.newDateReceive.length === 0 ||
      this.state.newInvoiceDate.length === 0 ||
      this.state.newInvoiceNo.length === 0 ||
      this.state.newPaymentDate.length === 0 ||
      this.state.newPaymentDays.length === 0 ||
      this.state.currencyType.length === 0 ||
      this.state.newCurrencyRate.length === 0
    )
  };

  handleUpdateCarat(carats) {
    const size = parseFloat(carats);
    const pricePerCarat = parseFloat(this.state.newPrice);
    const total = parseFloat(this.state.newTotal);

    if (pricePerCarat) {
      this.setState({ newTotal: parseFloat((Number(pricePerCarat) * Number(size)).toFixed(2)) });
    } else if (total) {
      this.setState({ newPrice: parseFloat((Number(total) / size).toFixed(2)) });
    }
  }

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add Lot Creation validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />
        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false} dialogClassName="confirmationModal">
          <Modal.Header closeButton>
            <Modal.Title>
              <img src={logo} height="40pt" width="40pt" alt={Constants.COMPANY_SITE} />
              &nbsp;&nbsp;
              {"Add New Lot Creation"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, width: "100%" }}>
              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Lot Int Id <sup style={{ color: "red" }}>*</sup></Typography>
                {this.props.editOperation ? (
                  <Typography>{this.props.sourceData.lotintimationid}</Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    placeholder="Enter Lot Int Id"
                    value={this.state.newLotintimationId}
                    disabled={this.props.disabled}
                    onBlur={() => this.validateLotCreationPresent(this.state.newLotintimationId)}
                    onChange={(e) => this.setState({
                      newLotintimationId: e.target.value,
                      lotintimationIdValidationError: Utility.CheckisNumberPositive(e.target.value)
                        ? "" : "Lot Int Id Should be a positive number",
                    })}
                    helperText={this.state.lotintimationIdValidationError}
                    error={this.state.lotintimationIdValidationError.length > 0}
                  />
                )}
                {this.state.showValidationMessage && (
                  <Box sx={{ marginTop: "8px" }}>
                    {this.state.validateLotCreationPresentSpinner ? (
                      <CircularProgress size="1rem" />
                    ) : this.state.lotCreationAvailable ? (
                      <Typography sx={{ color: "green", fontSize: "0.875rem" }}>
                        Lot Intimation is present
                      </Typography>
                    ) : (
                      <Typography sx={{ color: "red", fontSize: "0.875rem" }}>
                        Lot Intimation is not present
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>

              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Date Received<sup style={{ color: "red" }}>*</sup></Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        size="small"
                        {...props}
                      />
                    )}
                    value={this.state.newDateReceive}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const newDateReceive = dayjs(newValue).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      this.setState({ newDateReceive });
                    }}
                    maxDate={new Date()}
                  />
                </LocalizationProvider>
              </Box>

              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Price Per Carat <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Price Per Carat"
                  value={this.state.newPrice}
                  onChange={(e) => {
                    const pricePerCarat = e.target.value;
                    const carats = this.state.newCarat ? parseFloat(this.state.newCarat) : null;
                    const total = carats ? parseFloat((Number(pricePerCarat) * carats).toFixed(2)) : this.state.newTotal;
                    this.setState({
                      newPrice: pricePerCarat,
                      newTotal: total,
                      priceValidationError: Utility.CheckisNumberPositive(pricePerCarat)
                        ? "" : "Price Per Carat Should be a positive number",
                    });
                  }}
                  helperText={this.state.priceValidationError}
                  error={this.state.priceValidationError.length > 0}
                />
              </Box>

              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Total <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Total"
                  value={this.state.newTotal}
                  onChange={(e) => {
                    const totalValue = e.target.value;
                    const carats = this.state.newCarat ? parseFloat(this.state.newCarat) : null;
                    const pricePerCarat = carats ? parseFloat((Number(totalValue) / carats).toFixed(2)) : this.state.newPrice;
                    this.setState({ newTotal: totalValue, newPrice: pricePerCarat });
                  }}
                />
              </Box>

              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Carats <sup style={{ color: "red" }}>*</sup></Typography>
                {this.props.editOperation ? (
                  <Typography>{this.props.sourceData.carats}</Typography>
                ) : this.state.disableWeight ? (
                  <Typography>{this.state.newCarat}</Typography>
                ) : <Typography>-</Typography>}
              </Box>

              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Pcs <sup style={{ color: "red" }}>*</sup></Typography>
                {this.props.editOperation && this.props.sourceData.pcs ? (
                  <Typography>{this.props.sourceData.pcs}</Typography>
                ) : this.state.disablePcs && this.state.newPcs !== "" ? (
                  <Typography>{this.state.newPcs}</Typography>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    placeholder="Enter Pcs"
                    value={this.state.newPcs !== "" ? this.state.newPcs : 0}
                    onChange={(e) =>
                      this.setState({
                        newPcs: e.target.value,
                        pcsValidationError: Utility.CheckisNumberPositive(e.target.value)
                          ? "" : "Pcs Should be a positive number",
                      })
                    }
                    helperText={this.state.pcsValidationError}
                    error={this.state.pcsValidationError.length > 0}
                  />
                )}
              </Box>
              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Invoice Date<sup style={{ color: "red" }}>*</sup></Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        size="small"
                        {...props}
                      />
                    )}
                    value={this.state.newInvoiceDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const newInvoiceDate = dayjs(newValue).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      let newPaymentDate = dayjs(this.state.newPaymentDate).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      let newPaymentDays = this.state.newPaymentDays;

                      if (newPaymentDate < newInvoiceDate) {
                        newPaymentDays = "";
                        newPaymentDate = null;
                      }
                      else if (newPaymentDate) {
                        newPaymentDays = dayjs(newPaymentDate).diff(newInvoiceDate, "day");
                      } else if (newPaymentDays) {
                        newPaymentDate = dayjs(newInvoiceDate).add(Number(newPaymentDays), "day").toDate();
                      }

                      this.setState({ newInvoiceDate, newPaymentDate, newPaymentDays });
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Invoice No. <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  // type="number"
                  placeholder="Enter Invoice No"
                  value={this.state.newInvoiceNo}
                  onChange={(e) =>
                    this.setState({
                      newInvoiceNo: e.target.value,
                      invoiceNoValidationError: Utility.CheckisNumberPositive(e.target.value)
                        ? "" : "Invoice No Should be a positive number",
                    })
                  }
                />
              </Box>
              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Payment Date<sup style={{ color: "red" }}>*</sup></Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => (
                      <TextField
                        fullWidth
                        size="small"
                        {...props}
                      />
                    )}
                    value={this.state.newPaymentDate}
                    inputFormat="DD/MM/YYYY"
                    onChange={(newValue) => {
                      const now = dayjs();
                      const newPaymentDate = dayjs(newValue).hour(now.hour()).minute(now.minute()).second(now.second()).toDate();
                      let { newInvoiceDate } = this.state;
                      let newPaymentDays = this.state.newPaymentDays;

                      if (newPaymentDate < newInvoiceDate) {
                        newPaymentDays = "";
                        newInvoiceDate = null;
                      }
                      else if (newInvoiceDate) {
                        newPaymentDays = dayjs(newPaymentDate).diff(newInvoiceDate, "day");
                      } else if (newPaymentDays) {
                        newInvoiceDate = dayjs(newPaymentDate).subtract(Number(newPaymentDays), "day").toDate();
                      }

                      this.setState({ newPaymentDate, newInvoiceDate, newPaymentDays });
                    }}
                  />
                </LocalizationProvider>
              </Box>
              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Payment Days <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Payment Days"
                  value={this.state.newPaymentDays}
                  onChange={(e) => {
                    const newPaymentDays = e.target.value;

                    const { newInvoiceDate, newPaymentDate } = this.state;
                    let updatedPaymentDate = newPaymentDate;
                    let updatedInvoiceDate = newInvoiceDate;

                    if (newInvoiceDate) {
                      updatedPaymentDate = dayjs(newInvoiceDate).add(Number(newPaymentDays), "day").toDate();
                    } else if (newPaymentDate) {
                      updatedInvoiceDate = dayjs(newPaymentDate).subtract(Number(newPaymentDays), "day").toDate();
                    }

                    this.setState({
                      newPaymentDays, newPaymentDate: updatedPaymentDate, newInvoiceDate: updatedInvoiceDate,
                      paymentDaysValidationError: Utility.CheckisNumberPositive(e.target.value)
                        ? "" : "Payment Days Should be a positive number",
                    });
                  }
                  }
                />
              </Box>
              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Currency Type <sup style={{ color: "red" }}>*</sup></Typography>
                <Select
                  options={Constants.CURRENCY_TYPE}
                  value={Constants.CURRENCY_TYPE.find(option => option.value === this.state.currencyType)}
                  onChange={(selectedOption) => this.setState({ currencyType: selectedOption.value })}
                  placeholder="Select Currency"
                />
              </Box>
              <Box sx={{ flex: "1 1 48%" }}>
                <Typography>Currency Rate <sup style={{ color: "red" }}>*</sup></Typography>
                <TextField
                  fullWidth
                  size="small"
                  type="number"
                  placeholder="Enter Currency Rate"
                  value={this.state.newCurrencyRate}
                  onChange={(e) =>
                    this.setState({
                      newCurrencyRate: e.target.value,
                      currencyRateValidationError: Utility.CheckisNumberPositive(e.target.value)
                        ? "" : "Currency Rate Should be a positive number",
                    })
                  }
                />
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
